export class AutoAllocationService {
  http;

  constructor(http) {
    this.http = http;
  }

  async create(utilityId, title, effectiveDate, customerIds, projectIds) {
    return this.http.post('/allocations/auto-allocations', {
      utilityId,
      title,
      effectiveDate,
      customerIds,
      projectIds
    });
  }

  async delete(autoAllocationId) {
    return this.http.delete(`/allocations/auto-allocations/${autoAllocationId}`);
  }

  async fetchAutoAllocation(autoAllocationId) {
    return this.http.get(`/allocations/auto-allocations/${autoAllocationId}`);
  }

  async fetchDetails(autoAllocationId) {
    return this.http.get(`/allocations/auto-allocations/${autoAllocationId}/log`);
  }

  async fetchAll(utilityId) {
    return this.http.get(`/allocations/auto-allocations/`, {
      params: {
        utilityId,
        days: 10
      }
    });
  }

  async export(autoAllocationId) {
    return this.http.get(`/allocations/auto-allocations/${autoAllocationId}/export`, {
      responseType: 'blob'
    });
  }

  async exportLog(autoAllocationId) {
    return this.http.get(`/allocations/auto-allocations/${autoAllocationId}/log`, {
      responseType: 'blob'
    });
  }
}
